import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal, ResponsiveWidth } from '../../../../../common';
import { Order } from '../../../user-activity-items';
import { IOrderModal } from './order-modal.models';
import { setOrderNumber } from '../../../../../../graphql/order/order.cache';

export const OrderModal = ({
  points, storeData, products, orderNumber, orderStatus, orderId, deliveryDate, deliveryInformation,
  bonus, bonusId, purchaseDate, lastModifiedDateTime, rating, orderPrice, orderType, oldDeliveryDate, ...props
}: IOrderModal): JSX.Element => {
  useEffect(() => {
    return () => {
      setOrderNumber('');
    };
  }, []);

  return (
    <Modal
      {...props}
      title={<FormattedMessage
        id="order.card.title"
        values={{
          orderNumber,
        }}
      />}
      responsiveWidth={ResponsiveWidth.xsFull}
      content={(
        <Order
          isEditMode={false}
          points={points}
          storeData={storeData}
          products={products}
          status={orderStatus}
          orderId={orderId}
          deliveryDate={deliveryDate}
          oldDeliveryDate={oldDeliveryDate}
          lastModifiedDateTime={lastModifiedDateTime}
          bonus={bonus}
          bonusId={bonusId}
          purchaseDate={purchaseDate}
          rating={rating!}
          orderPrice={orderPrice}
          orderType={orderType}
          deliveryInformation={deliveryInformation}
        />
      )}
    />
  );
};
